var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"sticky-bar mb-6 py-2",attrs:{"flat":"","outlined":""}},[_c('v-card-text',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }